import React, { useState } from 'react';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PageHero from '../../components/PageHero';
import { Reveal, RevealGroup, RevealItem } from '../../components/Reveal';
import '../css/ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const infoCards = [
    { icon: <EmailOutlinedIcon />, title: 'Email', lines: ['info@company.com', 'support@company.com'] },
    { icon: <PhoneOutlinedIcon />, title: 'Phone', lines: ['+1 234 567 8900', '+1 234 567 8901'] },
    { icon: <LocationOnOutlinedIcon />, title: 'Address', lines: ['123 Business Street', 'City, State 12345'] },
    { icon: <AccessTimeOutlinedIcon />, title: 'Working Hours', lines: ['Mon - Fri: 9:00 - 18:00', 'Sat: 10:00 - 16:00'] },
  ];

  return (
    <div className="contact-page">
      <PageHero
        eyebrow="Get In Touch"
        title="Let's talk about your order."
        subtitle="Have a question or need a quote? Our export team responds within 24 hours."
      />

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <Reveal as="div" className="contact-info">
              <h2 className="section-title">Get in touch.</h2>
              <p>Have a question or need assistance? Feel free to reach out to us.</p>

              <RevealGroup className="info-cards">
                {infoCards.map((card, i) => (
                  <RevealItem key={i} className="info-card glass-card">
                    <div className="info-icon">{card.icon}</div>
                    <h3>{card.title}</h3>
                    {card.lines.map((line, j) => <p key={j}>{line}</p>)}
                  </RevealItem>
                ))}
              </RevealGroup>
            </Reveal>

            <Reveal as="div" className="contact-form-section" delay={0.15}>
              <h2 className="section-title">Send us a message.</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn-primary">Send Message</button>
              </form>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
